import reservacionReducer from './Reservacion';
import pasosReservacionReducer from './PasosFormulario';
import categoriaVehiculosReducer from './CategoriaVehiculos';
import categoriaVehiculosCatalogoReducer from './CategoriaVehiculosCatalogo';
import sucursalesReducer from './Sucursales';
import coberturasReducer from './Coberturas';
import serviciosReducer from './Servicios';
import fronterasReducer from './Fronteras';
import politicasReducer from './Politicas';
import vehiculoReducer from './Vehiculo';
import ubicacionesReducer from './Ubicaciones';
import enlacesReducer from './Enlaces';
import objetivosReducer from './Objetivos';
import puntosContactoReducer from './PuntosContacto';
import caruselReducer from './Carusel';
import monedaReducer from './CambioMoneda';
import loadingReducer from './Loading';
import crashingReducer from './Crashing';

import { reducer as reduxForm } from 'redux-form';
import { combineReducers } from 'redux';

const allReducers = combineReducers({
    loading: loadingReducer,
    reservacion: reservacionReducer,
    pasosReservacion: pasosReservacionReducer,
    categoriaVehiculos: categoriaVehiculosReducer,
    categoriaVehiculosCatalogo:categoriaVehiculosCatalogoReducer,
    sucursales: sucursalesReducer,
    vehiculo: vehiculoReducer,
    coberturas: coberturasReducer,
    servicios: serviciosReducer,
    fronteras: fronterasReducer,
    politicas: politicasReducer,
    ubicaciones: ubicacionesReducer,
    enlaces: enlacesReducer,
    objetivos: objetivosReducer,
    puntosContacto: puntosContactoReducer,
    carusel: caruselReducer,
    moneda: monedaReducer,
    crashing: crashingReducer,
    form: reduxForm
})

export default allReducers;